<template>
  <div class="app-container">
    <el-card class="box-card">
      <div class="filter-container">
        <el-form :model="query" ref="queryForm" :inline="true">
          <el-form-item label="大区姓名：" prop="keyword">
            <el-input v-model="query.keyword" placeholder="请输入姓名" size="small" clearable />
          </el-form-item>
          <el-form-item label="手机号：" prop="keyword">
            <el-input v-model="query.keyword" placeholder="请输入手机号" size="small" clearable />
          </el-form-item>
          <el-form-item label="时间筛选：">
            <el-select v-model="query.timeType" placeholder="请选择" clearable size="small">
              <el-option label="提交时间" :value="1"></el-option>
              <el-option label="同意时间" :value="2"></el-option>
              <el-option label="驳回时间" :value="3"></el-option>
            </el-select>
            <el-date-picker v-model="dateTime" size="small" type="datetimerange" value-format="yyyy-MM-dd HH:mm:ss"
              start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </el-form-item>
          <el-form-item class="fr">
            <el-button type="primary" @click="handleQuery" size="mini">搜索</el-button>
            <el-button type="info" @click="handleFilter" plain size="mini">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-card>
    <el-card class="box-card mt10">
      <div class="btn-right-side mb10">
        <el-tabs v-model="activeName" @tab-click="doQueryList({pageNo:1})">
          <el-tab-pane label="待审核" name="1"></el-tab-pane>
          <el-tab-pane label="同意申请" name="0"></el-tab-pane>
          <el-tab-pane label="驳回申请" name="0"></el-tab-pane>
        </el-tabs>
        <div class="btn-right-side mb10">
          <div class="btn-box">
            <el-button type="primary" size="mini" @click="handleDownload" plain>导出</el-button>
            <el-dropdown @command="handleCommand">
              <el-button type="primary" size="mini">批量操作<i class="el-icon--right el-icon-arrow-down"></i></el-button>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item :command="beforeHandleCommand(row,3)">批量同意</el-dropdown-item>
                <el-dropdown-item :command="beforeHandleCommand(row,4)">批量驳回</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
            <!-- <el-button type="primary" size="mini" @click="handleCreate" icon="el-icon-plus">添加客户</el-button> -->
          </div>
        </div>
      </div>
      <el-table v-loading="listLoading" :data="list" :key="activeName">
        <el-table-column label="编码" prop="realName" align="center" fixed>
          <template slot-scope="{row}">
              <div>{{row.realName}}
              </div>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column label="大区信息" prop="userPho" align="center" fixed>
          <template slot-scope="{row}">
              <div>{{row.realName}}</div>
              <div>{{row.realName}}</div>
            </template>
        </el-table-column>
        <el-table-column label="提现金额" prop="deptName" align="center" sortable/>
        <el-table-column label="提现账户" prop="entryTime" align="center" width="200"/>
        <el-table-column label="银行卡号" prop="entryTime" align="center" width="200"/>
        <el-table-column label="提交时间" prop="operatedTime" sortable align="center" width="200" />
        <!-- <el-table-column label="同意时间" prop="operatedTime" sortable align="center" width="200" /> -->
        <!-- <el-table-column label="打款状态" prop="entryTime" align="center" width="200"/>
        <el-table-column label="打款失败原因" prop="entryTime" align="center" width="200"/>
        <el-table-column label="驳回时间" prop="operatedTime" sortable align="center" width="200" />
        <el-table-column label="驳回原因" prop="entryTime" align="center" width="200"/> -->
        <el-table-column label="操作" align="center" fixed="right" width="280">
          <template slot-scope="{row}"  >
            <el-button type="text" @click="handleCreate(1,row)">同意</el-button>
            <el-button type="text" @click="handleUpdate(row,1)">驳回</el-button>
          </template>
        </el-table-column>
      </el-table>

      <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize"
        @pagination="doQueryList" />
    </el-card>
    <!-- 新建表单 -->
    <city-add ref="cityAdd" @created="doQueryList({})" :sectionList="sectionList" :popType="popType"/>
  </div>
</template>

<script>
  import cityCompanyApi from '@/api/sys/cityCompany'
  import sysDeptApi from '@/api/sys/sysDept'
  import Pagination from '@/components/Pagination'
  import userApi from '@/api/sys/user'
  import cityAdd from './add'
  // import customerLevelApi from '@/api/sys/customerLevel'
  export default {
    components: {
      Pagination,
      cityAdd
      // businessQuit,
      // businessAdjust,
      // areaRemove
    },
    data() {
      return {
        popType:null,
        list: [],
        total: 0,
        listLoading: true,
        query: {
          pageNo: 1,
          pageSize: 10,
          isInternal:1
        },
        sectionList: [],
        dateTime: null,
        activeName:'1'
      }
    },
    created() {
      this.doQueryList({
        pageNo: 1
      })
      this.getOption()
    },
    methods: {
      beforeHandleCommand(){

      },
      handleUpdate(row,type){
        if(type==2){
          this.popType=2
          this.$refs.cityAdd.handleUpdate(row)
        }
        this.$common.confirm(type==1?'是否确认提交离职，离职后该内部员工无法享受内部权益':'是否确认提交入职').then(() => {
          userApi.updateJobStatus({id:row.id,jobStatus:type==1?0:1}).then((res)=>{
            this.$message.success('操作成功')
            this.doQueryList({ pageNo: 1 })
          })
        })
          .then(() => {
            this.doQueryList({ pageNo: 1 })
          })
      },
      handleFilter() {
        this.query = {
          pageNo: 1,
          pageSize: 10,
          isInternal:1
        }
        this.doQueryList({
          pageNo: 1
        })
      },
      // 获取部门
      getOption(){
        sysDeptApi.findOptions().then(({data})=>{
          this.sectionList=data
        })
      },
      /**
       * 触发搜索操作
       */
      handleQuery() {
        this.doQueryList({
          pageNo: 1
        })
      },
      /**
       * 执行列表查询
       */
      doQueryList({
        pageNo,
        pageSize
      }) {
        if (pageNo) {
          this.query.pageNo = pageNo
        }
        if (pageSize) {
          this.query.pageSize = pageSize
        }
        this.query.jobStatus=this.activeName==1?1:0
        let query = {
          ...this.query,
        }

        if(this.query.timeType==1 && this.dateTime){
          query.entryTimeStart=this.dateTime[0]
          query.entryTimeEnd=this.dateTime[1]
        }
        if(this.query.timeType==2 && this.dateTime){
          query.operatedTimeStart=this.dateTime[0]
          query.operatedTimeEnd=this.dateTime[1]
        }
        if(this.query.timeType==3 && this.dateTime){
          query.resignationTimeStart=this.dateTime[0]
          query.resignationTimeEnd=this.dateTime[1]
        }
        delete query.timeType
        // if(!)
        this.listLoading = true
        return userApi.fetchList(query)
          .then(({
            data
          }) => {
            console.log("data: ", data);
            this.list = data.list
            this.total = data.total
          })
          .finally(() => {
            this.listLoading = false
          })
      },
      /**
       * 打开新建、编辑表单
       */
      handleCreate(type,row) {
        this.popType=type
        if(!type){
          this.$refs.cityAdd.handleCreate()
        }else{
          this.$refs.cityAdd.handleUpdate(row)
        }
      },
      //查看信息
      handleShowDetail(id){
        this.$emit('handleShow', id,2)
      },
    }
  }
</script>
